import { useQuery } from '@apollo/client';
import { useDealForecastStore } from '@openx/components-deal/lib/utils/context/DealForecastContext/DealForecastProvider.tsx';
import type { UseFetchDealForecast } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import type { DealForecastApiResponse } from '@openx/types/dealForecasting.ts';
import { BQ_JOB_MAX_REQUEST_COUNT, BQ_JOB_REFETCH_INTERVAL } from '@openx/utils/services/config.ts';
import {
  handleFetchForecastError,
  handleFetchForecastResponse,
} from '@openx/utils/state/deals/dealForecast/actions.ts';
import { useEffect, useRef } from 'react';
import { GetForecastDocument } from '../../../graphql/query/deals/GetDealForecast.generated.tsx';

export const useFetchDealForecast: UseFetchDealForecast = (job_id: string) => {
  const { dispatch } = useDealForecastStore();
  const responseCountRef = useRef(1);

  const { startPolling, stopPolling } = useQuery(GetForecastDocument, {
    notifyOnNetworkStatusChange: true,
    onCompleted: data =>
      handleFetchForecastResponse({
        MAX_REQUEST_COUNT: BQ_JOB_MAX_REQUEST_COUNT,
        data: structuredClone(data.dealForecastingJob) as DealForecastApiResponse,
        dispatch,
        reqCount: responseCountRef.current,
        stopPolling,
        updateReqCount: () => {
          responseCountRef.current += 1;
        },
      }),
    onError: error => {
      handleFetchForecastError({ dispatch, error, stopPolling });
    },
    variables: { job_id },
  });

  useEffect(() => {
    if (responseCountRef.current === 1) {
      startPolling(BQ_JOB_REFETCH_INTERVAL);
    }
  }, [startPolling]);
};
